import template from './garage-included-options.jade';
import includedOptions from '../../../enums/included-options';

export default angular
  .module('cian.addForm.priceGarageIncludedOptions', [])
  .directive('cianAfPriceAndDealTermsGarageIncludedOptions', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      function ($scope) {
        this.ad.bargainTerms.includedOptions = this.ad.bargainTerms.includedOptions || [];
        this.items = includedOptions.map(item => ({
          ...item,
          checked: this.ad.bargainTerms.includedOptions.indexOf(item.value) !== -1,
        }));

        $scope.$watch(
          () => this.items,
          newItems => {
            if (!newItems) {
              return;
            }
            this.ad.bargainTerms.includedOptions = newItems
              .map(item => (item.checked ? item.value : undefined))
              .filter(item => !!item);
          },
          true,
        );
      },
    ],
    controllerAs: 'includedOptions',
    template,
  })).name;
